/* PDP only (loaded by sections/main-product.liquid): the dropdowns of the sticky add to cart bar (variant list and quantity) with their own look:
   the list opens upwards, the chosen row is black, and it has its own scroll bar.
   The real selects (#variant-selector-sticky, #quantity-sticky) stay in the form, hidden: they are what is submitted and what the other scripts
   (pdp-sticky-sync.js and the sticky script of the section) set, so a dropdown here only mirrors its select and sets it when a row is chosen. */
(function () {
  var open = null;
  var counter = 0;
  // on a phone the variant list is as wide as the screen and the Rewards launcher is hidden while a list is open
  var phone = window.matchMedia('(max-width: 749px)');

  function dispatch(select, type) {
    select.dispatchEvent(new Event(type, { bubbles: true }));
  }

  // "MED / T-Shirt Heather Grey - $24.95 USD": the name and the price are separate, the price is only shown on a phone (CSS)
  function fill(element, option) {
    var full = option ? option.textContent.replace(/\s+/g, ' ').trim() : '';
    var cut = full.lastIndexOf(' - ');
    var hasPrice = cut > -1 && /\d/.test(full.slice(cut));
    element.textContent = '';
    var name = document.createElement('span');
    name.className = 'sticky-select__name';
    name.textContent = hasPrice ? full.slice(0, cut) : full;
    element.appendChild(name);
    if (hasPrice) {
      var price = document.createElement('span');
      price.className = 'sticky-select__price';
      price.textContent = full.slice(cut);
      element.appendChild(price);
    }
  }

  function enhance(select, kind) {
    var wrap = document.createElement('div');
    wrap.className = 'sticky-select sticky-select--' + kind;

    var id = 'sticky-select-list-' + ++counter;
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'sticky-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', id);
    var label = document.createElement('span');
    label.className = 'sticky-select__label';
    trigger.appendChild(label);
    trigger.insertAdjacentHTML(
      'beforeend',
      '<svg class="sticky-select__arrow" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none"><path d="M6 9L12 15L18 9" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );

    var list = document.createElement('ul');
    list.className = 'sticky-select__list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    list.setAttribute('aria-label', kind === 'quantity' ? 'Quantity' : 'Size');

    var rows = [];
    var active = -1;

    Array.prototype.forEach.call(select.options, function (option, index) {
      var row = document.createElement('li');
      row.className = 'sticky-select__option';
      row.id = id + '-' + index;
      row.setAttribute('role', 'option');
      fill(row, option);
      if (option.disabled) {
        row.classList.add('is-disabled');
        row.setAttribute('aria-disabled', 'true');
      }
      row.addEventListener('click', function () {
        choose(index);
      });
      list.appendChild(row);
      rows.push(row);
    });

    wrap.appendChild(trigger);
    wrap.appendChild(list);
    select.insertAdjacentElement('afterend', wrap);

    // the dropdown shows what the select holds
    function refresh() {
      var chosen = select.selectedIndex;
      var option = select.options[chosen];
      fill(label, option);
      rows.forEach(function (row, index) {
        var selected = index === chosen;
        row.classList.toggle('is-selected', selected);
        row.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }

    function setActive(index, scroll) {
      if (index < 0 || index >= rows.length) return;
      if (active > -1 && rows[active]) rows[active].classList.remove('is-active');
      active = index;
      rows[active].classList.add('is-active');
      list.setAttribute('aria-activedescendant', rows[active].id);
      if (scroll !== false) {
        // keep the row inside the visible part of the list
        var top = rows[active].offsetTop;
        var bottom = top + rows[active].offsetHeight;
        if (top < list.scrollTop) list.scrollTop = top;
        else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
      }
    }

    function move(direction) {
      var next = active;
      do {
        next += direction;
      } while (next >= 0 && next < rows.length && select.options[next].disabled);
      if (next >= 0 && next < rows.length) setActive(next);
    }

    function choose(index) {
      if (!select.options[index] || select.options[index].disabled) return;
      var changed = select.selectedIndex !== index;
      select.selectedIndex = index;
      refresh();
      close(true);
      if (changed) {
        dispatch(select, 'input');
        dispatch(select, 'change');
      }
    }

    // the list stands right above its dropdown (the gap is set in the CSS, over the top edge of the bar), and it is never taller than the room
    // above that: its bottom edge is 8px above the dropdown (the row of the dropdowns when the list is wider than its dropdown), 8px are kept
    // under the top of the screen
    function place() {
      var anchor = getComputedStyle(wrap).position === 'static' ? wrap.closest('.sticky-right') : wrap;
      if (!anchor) return;
      var bottomEdge = anchor.getBoundingClientRect().top - 8;
      // the phone's variant list is fixed to the screen (full width): its bottom edge is measured from the bottom of the screen
      list.style.bottom = phone.matches && kind === 'variant' ? Math.round(window.innerHeight - bottomEdge) + 'px' : '';
      list.style.maxHeight = Math.max(96, Math.min(500, Math.floor(bottomEdge - 8))) + 'px';
    }

    function show() {
      if (open && open !== api) open.close();
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      open = api;
      document.body.classList.add('sticky-select-open');
      place();
      // the list starts at the chosen row (centred when the list is long)
      var chosen = Math.max(0, select.selectedIndex);
      setActive(chosen, false);
      list.scrollTop = Math.max(0, rows[chosen].offsetTop - (list.clientHeight - rows[chosen].offsetHeight) / 2);
      list.focus({ preventScroll: true });
    }

    function close(returnFocus) {
      wrap.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (active > -1 && rows[active]) rows[active].classList.remove('is-active');
      active = -1;
      list.removeAttribute('aria-activedescendant');
      if (open === api) {
        open = null;
        document.body.classList.remove('sticky-select-open');
      }
      if (returnFocus) trigger.focus({ preventScroll: true });
    }

    var api = { close: close, wrap: wrap, place: place };

    trigger.addEventListener('click', function () {
      if (wrap.classList.contains('is-open')) close(false);
      else show();
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        show();
      }
    });

    list.addEventListener('keydown', function (event) {
      var key = event.key;
      if (key === 'ArrowDown') move(1);
      else if (key === 'ArrowUp') move(-1);
      else if (key === 'Home') setActive(select.options[0].disabled ? 1 : 0);
      else if (key === 'End') setActive(rows.length - 1);
      else if (key === 'Enter' || key === ' ') choose(active);
      else if (key === 'Escape') close(true);
      else if (key === 'Tab') close(false);
      else return;
      event.preventDefault();
      event.stopPropagation();
    });

    list.addEventListener('mousemove', function (event) {
      var row = event.target.closest('.sticky-select__option');
      var index = row ? rows.indexOf(row) : -1;
      if (index > -1 && index !== active && !select.options[index].disabled) setActive(index, false);
    });

    // the other scripts set the real select and tell it with an input / change event
    select.addEventListener('input', refresh);
    select.addEventListener('change', refresh);
    refresh();
  }

  function init() {
    var variant = document.getElementById('variant-selector-sticky');
    var quantity = document.getElementById('quantity-sticky');
    var bar = (variant || quantity || {}).parentElement;
    if (!bar) return;
    if (variant) enhance(variant, 'variant');
    if (quantity) enhance(quantity, 'quantity');
    bar.classList.add('is-enhanced');

    // the screen turned or its bars came / went: an open list stays right above its dropdown
    window.addEventListener('resize', function () {
      if (open) open.place();
    });

    document.addEventListener('click', function (event) {
      if (open && event.isTrusted && !open.wrap.contains(event.target)) open.close(false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
